import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryDataSource } from '../../api/query';
import { sourceIdBul } from '../../utils/raporSonek';
import type { ReportConfig } from '../../types/panelConfig';
import type { Donem } from './donem';

interface KanalSatiri {
  lokasyon: string;
}

/**
 * Sube listesi 040 "Satış Kanalı Özeti"nin `lokasyon` kolonundan TURETILIR -
 * elle yazilmis bir liste ya da config sabiti YOK (yeni sube acilirsa
 * kendiliginden gelir, kapanirsa kendiliginden gider).
 *
 * `queryKey` SubeBlok'unkiyle BIREBIR AYNI (`sa-sube-kanal`) - react-query
 * ayni anahtari paylasan iki tuketiciyi tek istekte birlestirir, yani bu
 * hook EK BIR AG CAGRISI ACMAZ.
 *
 * Donen liste sube secili DEGILKEN de dolar: secim `params`e girmez, cunku
 * secenek kumesi suzulmemis veriden okunmalidir (aksi halde bir sube
 * secildiginde listede yalniz o sube kalirdi ve geri donulemezdi).
 */
export function useSubeler(reports: ReportConfig[], donem: Donem): string[] {
  const params = { '@BASTARIH': donem.bas, '@BITTARIH': donem.bit };
  const idKanal = sourceIdBul(reports, 40, 'Satış Kanalı Özeti');

  const q = useQuery({
    queryKey: ['sa-sube-kanal', idKanal, params],
    queryFn: () => queryDataSource<KanalSatiri>({ sourceId: idKanal!, parameters: params }),
    enabled: !!idKanal,
    throwOnError: false,
  });

  return useMemo(() => {
    const rows = q.data?.data ?? [];
    const kume = new Set<string>();
    for (const r of rows) {
      const ad = String(r.lokasyon ?? '').trim();
      if (ad) kume.add(ad);
    }
    return Array.from(kume).sort((a, b) => a.localeCompare(b, 'tr'));
  }, [q.data]);
}
